import { useQuery } from 'react-query';
import { MISSING_REPORT_LIST } from 'api/missingInformationReport';
import api from 'api';
import { MissingReportReminderType } from 'api/types/missingInformationReportTypes';

export const useMissingInformationReport = <T extends MissingReportReminderType>(
  type: T,
  currentPage: number,
  itemsPerPage: number,
) => {
  return useQuery({
    queryKey: [MISSING_REPORT_LIST, type, currentPage, itemsPerPage],
    queryFn: () =>
      api.missingInformationReport.fetchMissingReportList({
        type,
        limit: itemsPerPage,
        page: currentPage + 1,
      }),
  });
}; 